import React from "react";
import {FileTextOutlined} from "@ant-design/icons";
import ComposerSection from "./ComposerSection";
import RulesPanel from "../../common/rulesPanel/RulesPanel";
import EmptyState from "../../common/emptyState/EmptyState";
import SorPaystubRow from "./SorPaystubRow";
import {buildEmptyPaystubRow, MAX_PAYSTUB_ROWS} from "../sor.model";

/**
 * SOR recent-paystubs section: a `RulesPanel` of `SorPaystubRow`s with the
 * shared add-row affordance and the composer-level validation message for
 * the array itself (row-level errors render inside each row).
 *
 * @param {Object} props
 * @param {Object[]} props.paystubs — `sor.recent_paystubs`
 * @param {Record<string, string>} [props.errors]
 * @param {boolean} [props.filled]
 * @param {(paystubs: Object[]) => void} props.onChange
 */
function SorPaystubsSection({paystubs, errors, filled, onChange}) {
    const rows = Array.isArray(paystubs) ? paystubs : [];

    const handleRowChange = (index, row) => onChange(rows.map((existing, rowIndex) => (rowIndex === index ? row : existing)));
    const handleRowRemove = index => onChange(rows.filter((_, rowIndex) => rowIndex !== index));
    const handleAdd = () => {
        if (rows.length >= MAX_PAYSTUB_ROWS) return;
        onChange([...rows, buildEmptyPaystubRow()]);
    };

    return (
        <ComposerSection icon={<FileTextOutlined />} title="Recent Paystubs" filled={filled}>
            <RulesPanel
                onAdd={handleAdd}
                addLabel={`Add a paystub row (${rows.length}/${MAX_PAYSTUB_ROWS})`}
                errorMessage={errors?.recent_paystubs}
                emptyState={<EmptyState title="No paystub history" description="Add rows to seed the SOR the model compares documents against — contradictions and contiguity both feed off these." />}>
                {rows.map((row, index) => (
                    <SorPaystubRow key={index} row={row} index={index} errors={errors} onChange={handleRowChange} onRemove={handleRowRemove} />
                ))}
            </RulesPanel>
        </ComposerSection>
    );
}

export default SorPaystubsSection;
